
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { DepartmentViewModel, ExecutionResult, ILegacyLookupService, LookupCriteria } from "@tylertech/tyler-api-types";

/**
 * HRDepartmentLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class HRDepartmentLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<DepartmentViewModel[]>> {
        return this.$apiService.sendAuth("IHRDepartmentLookupService/Lookup", pCriteria);
    }
}
